// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Combinators = require("../Data.Argonaut.Decode.Combinators/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Combinators = require("../Data.Argonaut.Encode.Combinators/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Shield = (function () {
    function Shield() {

    };
    Shield.value = new Shield();
    return Shield;
})();
var Dagger = (function () {
    function Dagger() {

    };
    Dagger.value = new Dagger();
    return Dagger;
})();
var Sword = (function () {
    function Sword() {

    };
    Sword.value = new Sword();
    return Sword;
})();
var showOffHandItem = new Data_Show.Show(function (v) {
    return "Shield";
});
var showMainHandItem = new Data_Show.Show(function (v) {
    if (v instanceof Dagger) {
        return "Dagger";
    };
    if (v instanceof Sword) {
        return "Sword";
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Equipment (line 24, column 10 - line 26, column 21): " + [ v.constructor.name ]);
});
var initEquipment = {
    mainHand: Data_Maybe.Nothing.value,
    offHand: Data_Maybe.Nothing.value
};
var eqOffHandItem = new Data_Eq.Eq(function (x) {
    return function (y) {
        return true;
    };
});
var ordOffHandItem = new Data_Ord.Ord(function () {
    return eqOffHandItem;
}, function (x) {
    return function (y) {
        return Data_Ordering.EQ.value;
    };
});
var eqMainHandItem = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Dagger && y instanceof Dagger) {
            return true;
        };
        if (x instanceof Sword && y instanceof Sword) {
            return true;
        };
        return false;
    };
});
var ordMainHandItem = new Data_Ord.Ord(function () {
    return eqMainHandItem;
}, function (x) {
    return function (y) {
        if (x instanceof Dagger && y instanceof Dagger) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Dagger) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Dagger) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Sword && y instanceof Sword) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Ritoppu.Model.Equipment (line 21, column 1 - line 21, column 52): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var encodeJsonOffHandItem = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("Shield"))(Data_Argonaut_Core.jsonEmptyObject);
});
var encodeJsonMainHandItem = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    if (v instanceof Dagger) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("Dagger"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof Sword) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("Sword"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Equipment (line 38, column 16 - line 44, column 27): " + [ v.constructor.name ]);
});
var decodeJsonOffHandItem = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json))(function (v) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString)(v)("item"))(function (v1) {
            if (v1 === "Shield") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(Shield.value);
            };
            return new Data_Either.Left("Unknown OffHandItem " + v1);
        });
    });
});
var decodeJsonMainHandItem = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json))(function (v) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString)(v)("item"))(function (v1) {
            if (v1 === "Dagger") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(Dagger.value);
            };
            if (v1 === "Sword") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(Sword.value);
            };
            return new Data_Either.Left("Unknown MainHandItem " + v1);
        });
    });
});
module.exports = {
    Dagger: Dagger,
    Sword: Sword,
    Shield: Shield,
    initEquipment: initEquipment,
    eqMainHandItem: eqMainHandItem,
    ordMainHandItem: ordMainHandItem,
    showMainHandItem: showMainHandItem,
    decodeJsonMainHandItem: decodeJsonMainHandItem,
    encodeJsonMainHandItem: encodeJsonMainHandItem,
    eqOffHandItem: eqOffHandItem,
    ordOffHandItem: ordOffHandItem,
    showOffHandItem: showOffHandItem,
    decodeJsonOffHandItem: decodeJsonOffHandItem,
    encodeJsonOffHandItem: encodeJsonOffHandItem
};
